<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="text-capitalize">
          {{ $t(`entities.location.multiple`) }}
        </h1>
      </v-col>
      <v-col>
        <v-btn
          class="text-none text-subtitle-1 text-capitalize"
          color="primary"
          rounded="xl"
          variant="outlined"
          prepend-icon="mdi-plus"
          data-cy="add-location-button"
          @click="addLocation()">
          {{
            $t("actions.add-element", {
              element: $t(`entities.location.name`)
            })
          }}
        </v-btn>
      </v-col>
    </v-row>

    <LocationsList />
  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useSpaceStore } from "@/stores/spaceStore";

import LocationsList from "./Locations/LocationsList.vue";
import { onMounted } from "vue";

const spaceStore = useSpaceStore();

// const route = useRoute();
// const tab = ref(route.params.tab || "locations");

// Cut off leading 's' from tab name
// const element = computed(() => tab.value.slice(0, -1));

const router = useRouter();

const addLocation = (id) => {
  let locationId = spaceStore.createElement("location");
  router.push({
    name: "calculations-location",
    params: { nodeId: locationId }
  });
  // isActive.value = true;
};
</script>

<style></style>
